import SectionHeading from "@/pages/home/components/SectionHeading";
import { storyParagraphs } from "@/mocks/about";

export default function Story() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
        <div className="relative order-2 lg:order-1">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20skincare%20spa%20brand%20story%20concept%20of%20a%20serene%20beauty%20space%20with%20soft%20dusty%20pink%20flowers%20candles%20and%20natural%20textures%20warm%20cream%20and%20blush%20tones%20minimalist%20editorial%20photography%20bright%20airy%20refined%20aesthetic&width=800&height=900&seq=bianca-story-1&orientation=portrait"
            alt="비앙카 피부관리 브랜드 스토리"
            title="비앙카 피부관리 - 브랜드 스토리"
            className="w-full h-auto object-cover object-top rounded-3xl"
          />
          <div className="absolute -bottom-6 -right-3 md:-right-6 bg-white rounded-2xl px-6 py-4 flex items-center gap-3 border border-background-200/70">
            <span className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-flower-line text-primary-500 text-xl"></i>
            </span>
            <div className="flex flex-col">
              <span className="text-lg font-bold text-foreground-900">10년</span>
              <span className="text-xs text-foreground-500">피부관리 경력</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-6 order-1 lg:order-2">
          <SectionHeading
            eyebrow="Our Story"
            title="피부 고민은 마음의 고민"
            align="left"
          />
          <div className="flex flex-col gap-4">
            {storyParagraphs.map((paragraph, index) => (
              <p key={index} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="grid grid-cols-3 gap-4 mt-2">
            {[
              { value: "10+", label: "전문 프로그램" },
              { value: "1:1", label: "맞춤 관리" },
              { value: "98%", label: "관리 만족도" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col items-center gap-1 py-4 rounded-2xl bg-background-100/70 border border-background-200/70"
              >
                <span className="text-xl md:text-2xl font-bold font-heading text-primary-600">{stat.value}</span>
                <span className="text-xs text-foreground-600">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}